<div class="sidePanel">
  <div class="sidePanel_header">
    <h3>Notifications</h3>
    <button mat-icon-button data-cy="notifications-sidenav-close-button" (click)="onPanelClose()">
      <mat-icon svgIcon="close" />
    </button>
  </div>

  <div class="sidePanel_body--notifications">
    @for (notification of notifications(); track $index) {
      <div class="d-flex flex-column" [attr.data-cy]="`notifications-sidenav-item-${notification.id}-row`">
        <div class="d-flex justify-content-between">
          <div class="d-flex align-items-center">
            <span class="d-flex">
              @switch (notification.status) {
                @case (NotificationsStatus.Completed) {
                  <mat-icon class="success" svgIcon="check-circle" />
                }
                @case (NotificationsStatus.Failed) {
                  <mat-icon class="warn" svgIcon="close-circle" />
                }
                <!-- Inline svg icon for Offline usage -->
                @case (NotificationsStatus.Unavailable) {
                  <mat-icon class="alert">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                      <path d="M10 3H14V14H10V3M10 21V17H14V21H10Z" />
                    </svg>
                  </mat-icon>
                }
                @default {
                  <mat-icon class="grey spin" svgIcon="loop" />
                }
              }
            </span>

            <span class="ms-2">{{ getTitle(notification) }}</span>
          </div>

          <!-- eslint-disable-next-line @angular-eslint/template/no-inline-styles -->
          <button
            class="text-muted"
            mat-icon-button
            [style.visibility]="
              notification.status === NotificationsStatus.Completed ||
              notification.status === NotificationsStatus.Failed
                ? 'visible'
                : 'hidden'
            "
            [attr.data-cy]="`notifications-sidenav-dismiss-${notification.id}-button`"
            (click)="removeNotification(notification.id)">
            <mat-icon svgIcon="close" />
          </button>
        </div>

        <div class="notification_message" [innerHTML]="getMessage(notification)"></div>

        <div class="d-flex align-items-center mt-2 notification_download">
          @if (notification.status === NotificationsStatus.Completed) {
            <button
              mat-stroked-button
              class="button--small color--primary"
              [attr.data-cy]="`notifications-sidenav-action-${notification.id}-button`"
              (click)="downloadReport(notification.data)">
              <span>{{ getActionLabel(notification) }}</span>
            </button>
          }

          <p class="ms-auto text-small text-muted mb-0">
            {{ getDate(notification.date) }}
          </p>
        </div>

        <hr class="extended" />
      </div>
    } @empty {
      <div class="d-flex justify-content-center py-3">
        <i>No new notifications from this session</i>
      </div>
    }
  </div>
</div>
